import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.thresholdData`;
export const INIT = `${SCOPE}/INIT`;
export const FILTERS_THRESHOLD_SCOPE = `${PARENT_SCOPE}.thresholdData.filtersData`;
export const TRENDS_THRESHOLD_SCOPE = `${PARENT_SCOPE}.thresholdData.trendsData`;
export const GET_THRESHOLD_DATA = `${SCOPE}/GET_THRESHOLD_DATA`;
export const SAVE_THRESHOLD_DATA = `${SCOPE}/SAVE_THRESHOLD_DATA`;
export const SET_THRESHOLD_ACTIVE_STATUS = `${SCOPE}/SET_THRESHOLD_ACTIVE_STATUS`;
export const SAVE_THRESHOLD_AND_REDIRECT = `${SCOPE}/SAVE_THRESHOLD_AND_REDIRECT`;
